import React from 'react'

const FooterTwo = () => {
  return (
    <div>
        <footer className="footer-two">
  <div className="sec-bg">
    <img src="assets/img/bg/sec-bg-wave.png" alt="Img" />
    <img src="assets/img/bg/anchor-img-02.png" alt="Img" />
  </div>
  <div className="container">
    <div className="footer-top">
      <div className="row">
        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
          <div className="footer-widget">
            <div className="widget-title">
              <h4>Company</h4>
              <ul className="footer-links">
                <li>
                  <a href="#">
                    <i className="fas fa-chevron-right" />
                    Our Company
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fas fa-chevron-right" />
                    Yacht Rent
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fas fa-chevron-right" />
                    Dreams rent USA
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fas fa-chevron-right" />
                    Dreams rent Worldwide
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fas fa-chevron-right" />
                    Dreams rent Category
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
          <div className="footer-widget">
            <div className="widget-title">
              <h4>Vehicles Type</h4>
              <ul className="footer-links">
                <li>
                  <a href="#">
                    <i className="fas fa-chevron-right" />
                    Electric
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fas fa-chevron-right" />
                    Scooters
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fas fa-chevron-right" />
                    Sports
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fas fa-chevron-right" />
                    Racing Bikes
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fas fa-chevron-right" />
                    Off-road
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
          <div className="footer-widget">
            <div className="widget-title">
              <h4>Quick links</h4>
              <ul className="footer-links">
                <li>
                  <a href="#">
                    <i className="fas fa-chevron-right" />
                    My account
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fas fa-chevron-right" />
                    Campaigns
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fas fa-chevron-right" />
                    Dreams rent Dealers
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fas fa-chevron-right" />
                    Deals and Incentive
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fas fa-chevron-right" />
                    Financial Services
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
          <div className="footer-widget">
            <div className="widget-title">
              <h4>Resources</h4>
              <ul className="footer-links">
                <li>
                  <a href="#">
                    <i className="fas fa-chevron-right" />
                    Support
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fas fa-chevron-right" />
                    Security
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fas fa-chevron-right" />
                    Help Centers
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fas fa-chevron-right" />
                    Preferences
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fas fa-chevron-right" />
                    Customers
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
          <div className="footer-widget">
            <div className="widget-title">
              <h4>Getting Started</h4>
              <ul className="footer-links">
                <li>
                  <a href="#">
                    <i className="fas fa-chevron-right" />
                    Introduction
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fas fa-chevron-right" />
                    Documentation
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fas fa-chevron-right" />
                    Usage
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fas fa-chevron-right" />
                    API
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fas fa-chevron-right" />
                    Elements
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
          <div className="footer-widget">
            <div className="widget-title">
              <h4>24/7 Live Support</h4>
              <ul className="footer-address">
                <li>Want to book a Yacht instantly Contact Us !!!</li>
                <li>Contact : + 1 (888) 760 1940</li>
                <li>Emergency : +1 68564 55664</li>
                <li>Email : support@example.com</li>
                <li className="social-link">
                  <ul>
                    <li>
                      <a href="#">
                        <i className="fa-brands fa-facebook-f" />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-brands fa-instagram" />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-brands fa-behance" />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-brands fa-twitter" />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-brands fa-pinterest-p" />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-brands fa-linkedin" />
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="footer-bottom">
      <div className="copy-right">
        <p>
          Copyright © 2024 <span> Namo Cars</span> . All Rights Reserved.
        </p>
      </div>
      <div className="app-store-links d-flex align-items-center">
        <span className="me-2">
          <a href="#">
            <img src="assets/img/icons/google-play.svg" alt="Img" />
          </a>
        </span>
        <span>
          <a href="#">
            <img src="assets/img/icons/app-store.svg" alt="Img" />
          </a>
        </span>
      </div>
    </div>
  </div>
</footer>

    </div>
  )
}

export default FooterTwo